export default {
    fsmRoute_routesTracker_modalfilters_title: "Filter By",   
    fsmRoute_routesTracker_modalfilters_clearFilters: 'Clear filters',
	fsmRoute_routesTracker_modalfilters_clearAll: 'Clear all',
    fsmRoute_routesTracker_modalfilters_close: 'Close',
    fsmRoute_routesTracker_modalfilters_no_driver: 'No Driver Assigned',
    fsmRoute_routesTracker_modalfilters_status: 'Status',
};